// src/pages/PoliticaDevoluciones.js
import React from 'react';
import "./LegalPages.css";

function PoliticaDevoluciones() {
  return (
    <div className="legal-page">
      <h1>📌 POLÍTICA DE DEVOLUCIONES Y CANCELACIONES - SANTO DOMINGO ESPECTÁCULOS</h1>
      <p>En Santo Domingo Espectáculos, nos esforzamos por brindar un servicio transparente y confiable. A continuación, detallamos nuestra política de devoluciones y cancelaciones.</p>
      
      <h2>1. Derechos reservados sobre devoluciones</h2>
      <p>✔ Todos los pagos realizados son finales y no son reembolsables.</p>
      <p>✔ No se aceptarán cancelaciones una vez que se hayan pagado y generado los boletos.</p>
      <p>✔ Si, por cualquier motivo, el cliente no puede asistir al evento, no habrá reembolsos ni cambios de fecha para su boleto.</p>
      
      <h2>2. Cancelación o reprogramación de eventos</h2>
      <p>Si un evento es cancelado o pospuesto por razones de fuerza mayor, el cliente tendrá las siguientes opciones:</p>
      <ul>
        <li>✅ Aceptar el cambio de fecha de su boleto para el mismo evento.</li>
        <li>✅ Cambiar su boleto por otro de igual o menor valor para otro evento disponible.</li>
        <li>✅ Solicitar el reembolso del monto pagado por los boletos.</li>
      </ul>
      
      <h3>🔹 Nota:</h3>
      <p>Si el cliente opta por un reembolso, la cantidad devuelta no incluirá el cargo por servicio cobrado por la plataforma en la gestión de la compra.</p>
      
      <h2>3. Plazo para reclamar cambios o reembolsos</h2>
      <p>✔ Una vez cancelado o pospuesto un evento, Santo Domingo Espectáculos notificará a los clientes que hayan adquirido boletos, indicando sus opciones.</p>
      <p>✔ El cliente tendrá un máximo de <strong>15 días hábiles</strong> para reclamar su cambio de boleto o solicitar un reembolso.</p>
      <p>✔ Pasado este plazo, el cliente perderá el derecho a cualquier reembolso o modificación en su compra.</p>
      Responsabilidad de la Plataforma
      <p>Santo Domingo Espectáculos es una plataforma tecnológica que actúa únicamente como canal de venta de boletos, brindando a los organizadores de eventos una herramienta para gestionar la comercialización de sus entradas y al público una vía para adquirirlas de forma segura.</p>

      <p>La plataforma no es la organizadora de los eventos ni tiene responsabilidad sobre la ejecución, calidad, modificaciones, cancelaciones, o reembolsos asociados a los mismos. La responsabilidad del evento recae exclusivamente sobre el organizador registrado.</p>

      <p>En caso de cancelación o posposición de un evento, Santo Domingo Espectáculos podrá actuar únicamente como medio facilitador de reembolsos, cuando aplique, siempre y cuando el organizador lo autorice y disponga de los fondos correspondientes.</p>

<     p>En situaciones de disputa, la plataforma pondrá a disposición del comprador los datos del organizador para facilitar la comunicación directa. No obstante, Santo Domingo Espectáculos no asume responsabilidad directa ni solidaria por reclamos económicos, daños o perjuicios derivados de decisiones tomadas por el organizador del evento.</p>
    </div>
  );
}
export default PoliticaDevoluciones;
